<template>
    <div class="flex -mt-px border-t border-b border-gray-200 bg-white">
        <div class="flex-1 -ml-px border-r border-gray-200 p-0" v-if="selectedPermission">
            <ui-select :options="permissionOptions" v-model="selectedPermission.name"
                       @change="permissionChanged"
                       select-class="m-0 p-1 mb-px border-none"></ui-select>
            <div :key="permissionKey">
                <div class="flex-1 border rounded border-gray-200 mx-1 mt-0.5 p-0.5 mb-1"
                     v-if="(selectedPermission && hasPackageScope(selectedPermission.name)) || actions.length">
                    <div v-if="actions.length">
                        <span
                            class="inline-block text-gray-400 text-xs whitespace-nowrap pl-2 pr-0 py-0.5 my-0.5 ml-0"
                            v-text="'Actions:'">
                        </span>
                        <span
                            class="inline-block font-bold text-gray-500 text-xs whitespace-nowrap px-0.5 py-0.5 my-0.5 ml-1"
                            v-for="(action,index) in actions" :key="action.name">
                            <span v-text="action.name"></span>
                            <span class="text-gray-400 pl-1 hover:text-red-400">
                                <input type="checkbox"
                                       :checked="selectedPermission.actions.some((i) => i === action.name )"
                                       @change="(o) => actionChanged(selectedPermission,action,o)"/>
                            </span>
                        </span>
                    </div>
                    <template v-if="(selectedPermission && hasPackageScope(selectedPermission.name))">
                        <div>
                        <span
                            class="inline-block text-gray-400 text-xs whitespace-nowrap pl-2 pr-0 py-0.5 my-0.5 ml-0"
                            v-text="'Packages:'">
                        </span>
                            <span
                                class="inline-block font-bold text-gray-500 text-xs border border-gray-200 whitespace-nowrap px-2 py-0.5 rounded my-0.5 ml-1"
                                v-for="(sPackage,index) in selectedPackages" :key="sPackage">
                            <span v-text="sPackage"></span>
                            <span class="text-gray-400 fa fa-times pl-1 hover:text-red-400"
                                  @click="selectedPackages.splice(index,1); update()"></span>
                        </span>
                        </div>
                        <div
                            class="text-gray-500 text-xs whitespace-nowrap mx-2 my-0.5 p-0">
                            <ui-dropdown placement="bottom-start" menu-class="w-full max-w-lg" ref="inlineSearch">
                                <template #default="{ open, close }">
                                    <div class="flex w-full items-center">
                                        <page-cell name="search"
                                                   v-model="search"
                                                   ref="searchBox"
                                                   @keydown.esc.stop="() => {closeSlide()}"
                                                   @input="open"
                                                   @focus="open"
                                                   @keydown.enter="addPackage"
                                                   placeholder="Add package..."
                                                   :style="'box-shadow:none !important'"
                                                   class="mx-1 py-0.5 px-1.5 text-gray-400 border-none border-transparent resize-none outline-none shadow-none ring-0 bg-transparent text-sm mb-0 w-full">
                                        </page-cell>
                                    </div>
                                </template>
                                <template #menu="{ close }">
                                    <div class="p-3 max-h-64 overflow-y-auto" v-if="search">
                                        <div v-for="foundPackage in searchPackages(search)">
                                            <div
                                                class="relative group py-1.5 px-2 flex items-center hover:bg-gray-50 rounded-lg"
                                                @click="(e) => {
                                            search = '';
                                            if (!selectedPackages.includes(foundPackage.referenceNumber)) {
                                                selectedPackages.push(foundPackage.referenceNumber);
                                            }
                                            update()
                                            close()
                                        }">
                                                <div class="flex-1 flex items-center min-w-0 relative">
                                            <span class="flex-shrink-0 font-medium inline-block relative"
                                                  v-text="foundPackage.referenceNumber"></span>
                                                    <div class="ml-1 w-full truncate">
                                                        <div class="text-sm font-medium text-gray-900 flex w-full">
                                                            <div class="flex-grow truncate"
                                                                 v-text="foundPackage.name"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-else class="p-3 max-h-64 overflow-y-auto">
                                        Start typing to search packages
                                    </div>
                                </template>
                            </ui-dropdown>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <div class="w-6 flex-shrink-0" v-if="removable"><i
            class="ml-2 mt-2.5 text-xs fa fa-times text-gray-300 hover:text-red-400"
            @click="$emit('remove')"></i>
        </div>
    </div>
</template>

<script>
import UiInput from "../ui/UiInput.vue";
import PackageContactSearch from "../contacts/PackageContactSearch.vue";
import UiDataGridItem from "../ui/UiDataGridItem.vue";
import UiDataGrid from "../ui/UiDataGrid.vue";
import UiSelect from "../ui/UiSelect.vue";
import UiSelectSearchable from "../ui/UiSelectSearchable.vue";
import PageCell from "../ui/PageCell.vue";
import MessageWidgetChannelAvatars from "../widgets/MessageWidget/MessageWidgetChannelAvatars.vue";
import UiDropdown from "../ui/UiDropdown.vue";

export default {
    components: {
        UiDropdown,
        MessageWidgetChannelAvatars,
        PageCell,
        UiSelectSearchable, UiSelect, UiDataGrid, UiDataGridItem, PackageContactSearch, UiInput
    },
    props: {
        availablePermissions: [],
        packages: [],
        option: null,
        removable: false
    },
    data() {
        return {
            search: '',
            permissionOptions: this.availablePermissions.map((i) => {
                return {'label': i.name, 'value': i.name}
            }),
            permissionKey: 0,
            selectedPermission: null,
            selectedPackages: [],
            actions: [],
        }
    },
    methods: {
        actionChanged(permission, action, o) {
            let index = permission.actions.indexOf(action.name);
            if (index >= 0) {
                permission.actions.splice(index, 1)
            }
            if (o.target.checked) {
                permission.actions.push(action.name)
            }
            this.update()
        },
        permissionChanged() {
            this.actions = this.availablePermissions.find((i) => i.name === this.selectedPermission.name).actions;
            this.permissionKey++;
            this.update()
        },
        searchPackages(search) {
            return this.packages.concat([{
                referenceNumber: 'All',
                name: '*'
            }]).filter((i) => (i.referenceNumber.concat(' ', i.name).toLowerCase().indexOf(search.toLowerCase()) > -1))
        },
        hasPackageScope(permission) {
            let option = (this.availablePermissions.length) ? this.availablePermissions.find((i) => i.name === permission) : false;
            return permission && option && (option.scopes.includes('packageReference'));
        },
        update() {
            let ob = {
                id: this.selectedPermission.id,
                name: this.selectedPermission.name,
                context: this.availablePermissions.find((i) => i.name === this.selectedPermission.name).context,
                type: this.availablePermissions.find((i) => i.name === this.selectedPermission.name).type,
                actions: this.selectedPermission.actions,
                scopes: null,
            };
            if (this.hasPackageScope(this.selectedPermission.name)) {
                ob.scopes = {
                    packageReference: this.selectedPackages.map((i) => {
                        return {
                            packageReference: i,
                            actions: this.selectedPermission.actions
                        };
                    })
                }
            }
            this.$emit("update", ob);
        },
    },
    mounted() {
        this.selectedPermission = this.option;
        this.actions = this.availablePermissions.find((i) => i.name === this.selectedPermission.name).actions;
        if (this.hasPackageScope(this.option.name)) {
            this.selectedPackages = this.option.scopes.packageReference ? this.option.scopes.packageReference.map((i) => i.packageReference === '*' ? 'All' : i.packageReference) : [];
        }
    }
}
</script>
